/**
 * Normalize the hostname of a URL.
 * @param url - The URL to normalize.
 * @returns The normalized hostname.
 */
function normalizeHostname(url: string): string {
  if (url.indexOf("http") === 0) {
    return new URL(url).hostname;
  }

  return url;
}

/**
 * Check if the app is running in the development environment.
 * @param hostname - The hostname of the app.
 * @returns `true` if the app is running in the development environment, `false` otherwise.
 */
export function isDevEnv(hostname = window.location.hostname): boolean {
  const urls = ["localhost", ".localhost", "127.0.0.1", ".127.0.0.1", ".numberly.dev"];
  const regexp = new RegExp(`^(${urls.join(")|(")})$`);

  return normalizeHostname(hostname).search(regexp) > -1;
}

/**
 * Check if the app is running in the staging environment.
 * @param hostname - The hostname of the app.
 * @returns `true` if the app is running in the staging environment, `false` otherwise.
 */
export function isStagingEnv(hostname = window.location.hostname): boolean {
  return hostname.includes(".numberly.st");
}

/**
 * Check if the app is running locally.
 * @returns `true` if the app is running locally, `false` otherwise.
 */
export function isRunningLocally() {
  return ["127.0.0.1", "localhost"].some((host) => window.location.hostname.includes(host));
}
